var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0719 16.6898C15.6702 17.0915 15.6702 17.7427 16.0719 18.1444C16.4736 18.5461 17.1248 18.5461 17.5265 18.1444L23.0122 12.6587C23.4139 12.257 23.4139 11.6058 23.0122 11.2041L17.5265 5.71838C17.1248 5.31669 16.4736 5.31669 16.0719 5.71838C15.6702 6.12006 15.6702 6.77131 16.0719 7.173L19.8017 10.9028L9.53033 10.9028C9.18949 10.9028 8.91319 11.3633 8.91319 11.9314C8.91319 12.4995 9.18949 12.96 9.53033 12.96L19.8017 12.96L16.0719 16.6898ZM4.28075 21.9429L16.2274 21.9429C16.7324 21.9429 17.1417 22.4034 17.1417 22.9714C17.1417 23.5395 16.7324 24 16.2274 24L4.28075 24C2.31305 24 0.684561 22.3345 0.684561 20.2286L0.684561 3.77143C0.684561 1.6655 2.31305 0 4.28075 0L16.2274 0C16.7324 0 17.1417 0.460509 17.1417 1.02857C17.1417 1.59664 16.7324 2.05714 16.2274 2.05714L4.28075 2.05714C3.28611 2.05714 2.51313 2.84769 2.51313 3.77143L2.51313 20.2286C2.51313 21.1523 3.28611 21.9429 4.28075 21.9429Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.c9d236354c06c179dc2c1fa7d871dde1.svg";
export { ForwardRef as ReactComponent };